import config from '../../config';
import { getHostedDashboardServiceHost, isDashboardLocalDebugMode, isLocalLikeHost } from '../../utils/environmentMode';

export const shipmentHost = config.config.api_shipments.admin.shipmentHost;
export const hasuraHost = config.config.api_shipments.admin.hasuraHost;
export const wssHasuraHost = config.config.api_shipments.admin.wssHasuraHost;
const resolveHostedShipmentHost = () => {
	const developmentHost = 'https://dev-api-shipments.gophr.app';
	const productionHost = 'https://api-shipments.gophr.app';

	if (isDashboardLocalDebugMode()) {
		return process.env.REACT_APP_LOCAL_DEBUG_HOSTED_STAGE === 'production'
			? productionHost
			: developmentHost;
	}

	return getHostedDashboardServiceHost({
		developmentHost,
		productionHost
	});
};

export const hostedShipmentHost = resolveHostedShipmentHost();

export const toHostedShipmentUrl = url => {
	if (typeof url !== 'string') {
		return url;
	}

	if (!isLocalLikeHost(shipmentHost)) {
		return url;
	}

	return url.startsWith(shipmentHost) ? `${hostedShipmentHost}${url.slice(shipmentHost.length)}` : url;
};

//admin routes
export const shipmentEndpoint = shipmentHost + '/shipments/';
export const createMerchantAndStore = shipmentHost + '/admins/stores/create/merchant';
export const dropShipmentsEndpoint = shipmentHost + '/admins/dropshipments';
export const createDropShipment = shipmentHost + '/admins/dropship/create';
export const editDropShipment = shipmentHost + '/admins/dropship/edit';
export const deleteDropShipment = shipmentHost + '/admins/dropship/delete';
export const completeDropShipment = shipmentHost + '/admins/shipments/';
export const completeDropRoute = shipmentHost + '/admins/routes/';
export const getQuote = shipmentHost + '/shipments/dropship/quote';
export const adminShipment = shipmentHost + '/admins/shipments/';
export const adminRoute = shipmentHost + '/admins/routes/';
export const adminOrder = shipmentHost + '/admins/orders/';
export const adminDispatchShipments = shipmentHost + '/shipments/admin-dispatch-shipments';
export const smartDispatchStartRoute = shipmentHost + '/dispatch/start/route/';
export const smartDispatchAdminRouteSummary = shipmentHost + '/dispatch/admin/route/';
export const adminDispatchRoutes = shipmentHost + '/shipments/admin-dispatch-routes';
export const adminGoPilotReviews = shipmentHost + '/admins/shipments/gopilot/reviews';
export const getAdminShipmentForceReadyUrl = shipmentId => adminShipment + shipmentId + '/ready/override';
export const getAdminShipmentQuoteOverrideUrl = shipmentId => adminShipment + shipmentId + '/shipping_fee/update';
export const getResolveExternalDriverPaymentUrl = (shipmentId, payId) => `${adminShipment}${shipmentId}/driver-pays/${payId}/resolve-external`;
export const adminCustomerDriverReviewByShipment = shipmentId => `${shipmentHost}/admins/shipments/${shipmentId}/customer-driver-review`;
